import React from 'react';
import { FormCheckbox } from 'shards-react';
import PropTypes from 'prop-types';
import { Flex } from '../common/Flex';

class PaymentOrderInput extends React.Component {
  handleChange = (orderBy) => this.props.handleInputChange({ orderBy });

  render() {
    const orderBy = this.props.values?.orderBy || 'created_at';

    return (
      <Flex justifyContent="space-evenly">
        <FormCheckbox
          checked={orderBy === 'created_at'}
          onChange={() => this.handleChange('created_at')}
        >
          Fecha de Creación
        </FormCheckbox>
        <FormCheckbox
          checked={orderBy === 'payment_date'}
          onChange={() => this.handleChange('payment_date')}
        >
          Fecha de Pago
        </FormCheckbox>
      </Flex>
    );
  }
}

PaymentOrderInput.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  values: PropTypes.object
};

export default PaymentOrderInput;
